export { NotesAndTermsInput } from "./components/NotesAndTermsInput";
export { useNotesAndTerms } from "./hooks/useNotesAndTerms";
